import axios from "axios";

// export const baseUrl = "http://localhost:8420/";
// export const baseUrl = "https://ccp-ogb.quizmasterr.com/";
export const baseUrl="/";

// export const baseUrl="https://ccpmrw.quizmasterr.com/";
export const upload_File=async (formData)=>{
    const res = await axios.post(
                `${baseUrl}api/v1/file/upload-excel`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return res

}

export const loginApi = async (username, password) => {
    const response = await axios.post(`${baseUrl}api/v1/login`, {
        username, password
    });
    return response;
}

export const misApi = async (startDate, endDate, tokenData) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/new-mis`, {
        startDate, endDate
    }, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    });
    return response;
}

export const liveMisApi = async (tokenData) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/live-mis`, null, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    });
    return response;
}

export const userLogsApi = async (msisdn, tokenData) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/user-logs`, {
        msisdn
    }, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    });
    return response;
}

export const leaderboardApi = async (startDate, endDate, tokenData) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/leaderboard`, {
        startDate, endDate
    }, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    });
    return response;
}

export const getBlacklistNumbersApi = async (tokenData) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/get-blacklisted-numbers`, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    });

    return response;
}

export const blacklistMsisdnApi = async (msisdn, tokenData) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/blacklist-msisdn`, {
        msisdn
    }, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    });

    return response;
}

export const unsubMsisdnApi = async (msisdn, tokenData) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/unsub-msisdn`, {
        msisdn,alias:msisdn
    }, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    })

    return response;
}
// export const uplodDND= async (xmlData) => {
//   try {
//     // 1. Determine if we are sending a raw XML string or a File object
//     const isFile = xmlData instanceof File;
    
//     // 2. Set the appropriate headers
//     const headers = {
//       'Content-Type': isFile ? 'multipart/form-data' : 'application/xml',
//     };

//     // 3. Prepare the payload
//     let payload = xmlData;
//     if (isFile) {
//       payload = new FormData();
//       payload.append('xmlFile', xmlData);
//     }

//     // 4. Make the POST request
//     const response = await axios.post('/api/upload-xml', payload, { headers });
//     return response.data;
    
//   } catch (error) {
//     console.error('Error uploading XML:', error.response?.data || error.message);
//     throw error;
//   }
// };